import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

interface Props {
  needsService: boolean;
  needsServiceReason: string;
  onNeedsServiceChange: (value: boolean) => void;
  onReasonChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Shared "Needs Service" toggle used across yard flows (check-in, audit).
 * Persistence lives in the caller — this component only manages the UI.
 * When toggled off, the caller should clear reason/set_at/set_by fields.
 */
export function NeedsServiceToggle({
  needsService,
  needsServiceReason,
  onNeedsServiceChange,
  onReasonChange,
  disabled,
}: Props) {
  return (
    <div className="space-y-2 rounded-lg border p-3">
      <div className="flex items-center justify-between">
        <div>
          <Label className="text-sm font-medium">Needs Service</Label>
          <p className="text-xs text-muted-foreground mt-0.5">
            Trailer requires maintenance and should not be dispatched
          </p>
        </div>
        <Switch
          checked={needsService}
          disabled={disabled}
          onCheckedChange={(v) => {
            onNeedsServiceChange(v);
            if (!v) onReasonChange("");
          }}
        />
      </div>
      {needsService && (
        <div className="space-y-1.5 pt-1">
          <Label className="text-xs">What's wrong? *</Label>
          <Textarea
            placeholder="Describe the issue (e.g. flat tire, broken light, refrigeration unit fault)..."
            value={needsServiceReason}
            onChange={(e) => onReasonChange(e.target.value)}
            rows={3}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}